<h2 class="nomargin">Preview mapping</h2>
<span class="subheading">See how this journal entry will look in your accounting software</span>

<ng-container *ngIf="reservationsState$ | async as state">
  <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

  <mat-form-field *ngIf="!state.loading" class="fw">
    <mat-select
      placeholder="Select a reservation"
      (selectionChange)="onReservationSelect($event)"
      [disabled]="loadingPreview$ | async">
      <mat-option *ngFor="let reservation of state.data" [value]="reservation.uuid">
        <div fxLayoutAlign="start center" fxLayoutGap="8px">
          <img class="checkin__icon" [src]="'/assets/iconography/' + reservation.platform + '.svg'" />
          <span>
            {{ reservation.guest_name }},
            <span *ngIf="reservation.checkin" class="text-xs text-night">&nbsp;{{ reservation.checkin }}</span>
            <span class="text-xs text-night">&nbsp;({{ reservation.code }})</span>
          </span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <sbnb-loading-spinner *ngIf="loadingPreview$ | async"></sbnb-loading-spinner>
  <sbnb-hero-card *ngIf="previewData$ | async as previewData">
    <div class="grid grid-cols-3 gap-2 text-night">
      <div class="strong"></div>
      <div class="strong text-right">Debit</div>
      <div class="strong text-right">Credit</div>

      <ng-container *ngFor="let item of previewData">
        <div class="flex flex-col">
          <span>{{ item.account_name }}</span>
          <span class="text-xs text-night-lighter">{{ item.description }}</span>
        </div>
        <div class="flex items-center justify-end">
          <ng-container *ngIf="item.type === 'debit'">
            <div class="font-mono text-right">{{ item.total_amount }}</div>
          </ng-container>
        </div>
        <div class="flex items-center justify-end">
          <ng-container *ngIf="item.type === 'credit'">
            <div class="font-mono text-right">{{ item.total_amount }}</div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </sbnb-hero-card>
</ng-container>

<div class="w-full flex justify-end mt-4">
  <sbnb-button [disabled]="loadingPreview$ | async" (click)="closePreview()">Close preview</sbnb-button>
</div>
